import { render, staticRenderFns } from "./WatResources.vue?vue&type=template&id=2748c17b&"
import script from "./WatResources.vue?vue&type=script&lang=js&"
export * from "./WatResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports